<form [formGroup]="controleFormGroup">
  <dsd-container>
    <dsd-fieldset [quietValidate]="true">
      <span slot="legend">
        <h2 class="dsd-t-4 dsd-fw-bold" tabindex="-1">{{ 'caad.modifier.courriel.libelle.courriel' | translate }}</h2>
      </span>
      <h3 class="dsd-t-6">
        {{
          (compteActif
            ? compteActif.infosCarte.descriptionCourte
            : coordonneesClient?.comptesDetention?.[0].infosCarte.descriptionCourte
          ) | titlecase
        }}
        <span aria-hidden="true"
          >{{
            (compteActif
              ? compteActif.infosCarte.numeroCarte
              : coordonneesClient?.comptesDetention?.[0].infosCarte.numeroCarte
            ) | masquerCarte
          }}
        </span>
        <span class="dsd-sr-only"
          >{{ 'caad.accueil.libelle.horsEcran.carteCreditTerminant' | translate }}
          {{
            (compteActif
              ? compteActif.infosCarte.numeroCarte
              : coordonneesClient?.comptesDetention?.[0].infosCarte.numeroCarte
            ).substring(12, 16)
          }}</span
        >
      </h3>
      <dsd-input
        maxlength="50"
        identifier="courriel"
        required="true"
        class="dsd-mb-0 input-info"
        formControlName="courriel"
        name="courriel"
        type="email"
        [error]="erreursFormCourriel.courriel.hasError"
        [quietValidate]="true">
        <span slot="label">{{ 'formulairePosteCanada.courriel.titre' | translate }}</span>
        <span slot="error">
          <app-erreur-input [erreurInput]="erreursFormCourriel.courriel"></app-erreur-input>
        </span>
      </dsd-input>
      <div class="section-autre-courriel dsd-mt-md" *ngIf="comptesFiltres.length > 0">
        <div *ngIf="comptesFiltres.length === 1; else choixCartesMultiples">
          <h3 class="dsd-t-6 dsd-mb-sm">{{ 'caad.modifier.courriel.libelle.autreCarte.titre' | translate }}</h3>
          <p>{{ 'caad.modifier.courriel.libelle.autreCarte.description' | translate }}</p>
        </div>
        <ng-template #choixCartesMultiples>
          <h3 class="dsd-t-6 dsd-mb-sm">{{ 'caad.modifier.courriel.libelle.autresCartes.titre' | translate }}</h3>
          <p>{{ 'caad.modifier.courriel.libelle.autresCartes.description' | translate }}</p>
        </ng-template>
        <dsd-checkbox-group
          hide-required-labelling="true"
          column
          identifier="cartes-group"
          sm-items-per-row="1"
          md-items-per-row="1"
          class="dsd-mt-sm">
          <span slot="legend" *ngIf="comptesFiltres.length === 1">{{
            'caad.modifier.courriel.libelle.autreCarte.choisirCarteLibelle' | translate
          }}</span>
          <span slot="legend" *ngIf="comptesFiltres.length > 1">{{
            'caad.modifier.courriel.libelle.autresCartes.choisirCarteLibelle' | translate
          }}</span>

          <dsd-select-tile
            *ngFor="let compteDetention of comptesFiltres"
            [value]="compteDetention.infosCompte.numeroCompte"
            (change)="cocher($event)"
            [checked]="isChecked(compteDetention.infosCompte.numeroCompte)"
            title-highlight>
            <span slot="label"
              >{{ compteDetention.infosCarte.descriptionCourte | titlecase }}
              <span class="dsd-sr-only"
                >{{ 'caad.accueil.libelle.horsEcran.carteCreditTerminant' | translate }}
                {{ compteDetention.infosCarte.numeroCarte.substring(12, 16) }}</span
              >
            </span>
            <span slot="subtitle">
              <span *ngIf="compteDetention.infosCompte.adresseCourriel">
                {{ compteDetention.infosCompte.adresseCourriel }}
              </span>
              <span>
                {{
                  compteDetention.infosCompte.adresseCourriel
                    ? ''
                    : ('caad.modifier.courriel.libelle.adresseCourrielVide' | translate)
                }}
              </span>
            </span>
            <span slot="text" aria-hidden="true">
              {{ compteDetention.infosCarte.numeroCarte | masquerCarte }}
            </span>
          </dsd-select-tile>
        </dsd-checkbox-group>
      </div>
    </dsd-fieldset>
  </dsd-container>

  <div class="zone-btn">
    <dsd-button variant="primary" (dsdButtonClick)="onSubmit()" fullWidth="xs">{{
      'caad.button.valider' | translate
    }}</dsd-button>
    <dsd-button (dsdButtonClick)="annulerModification()" fullWidth="xs">{{
      'caad.button.annuler' | translate
    }}</dsd-button>
  </div>
</form>
